<template>
    <span
        class="group flex h-full flex-col border border-gray-200 bg-white hover:border-primary-500 dark:border-gray-700 dark:bg-gray-900"
    >
        <span
            class="flex items-center justify-center bg-gray-100 text-gray-700 dark:bg-gray-800 dark:text-gray-300"
        >
            <span class="relative block max-h-[16rem] min-h-[16rem] w-full p-4">
                <img
                    v-if="child.icon !== null && child.icon.url !== null"
                    :src="child.icon.url"
                    :alt="child.title"
                    class="m-auto max-h-[14rem] shadow-lg"
                />
                <storefront-icon-glyph-render
                    v-else-if="child.icon !== null && child.icon.glyph !== null"
                    :glyph="child.icon.glyph"
                />
            </span>
        </span>
        <span class="flex flex-1 flex-col p-4">
            <span
                class="text-xl font-medium text-gray-900 dark:text-gray-100"
                >{{ child.title }}</span
            >
            <span
                v-if="child.__typename === 'StorefrontPlan'"
                class="line-height-3 mt-2 flex-1 text-gray-700 dark:text-gray-400"
            >
                <span
                    class="ContentReset"
                    v-html="child.subtitle"
                />
            </span>
            <span
                v-else-if="
                    child.__typename === 'StorefrontCatalog' ||
                    child.__typename === 'StorefrontCalendar'
                "
                class="line-height-3 mt-2 flex-1 text-gray-700 dark:text-gray-400"
            >
                <content-reset :body="child.shortSummaryMarkup" />
            </span>
            <span class="mt-2 flex justify-end">
                <prime-button
                    :outlined="
                        child.__typename === 'StorefrontPlan' ? undefined : true
                    "
                    class="p-1"
                >
                    {{ callToActionLanguage }}
                </prime-button>
            </span>
        </span>
    </span>
</template>

<script setup lang="ts">
import StorefrontIconGlyphRender from '~/components/Storefront/StorefrontIconGlyphRender.vue'
import PrimeButton from 'primevue/button'
import type {
    StorefrontCalendarScalar,
    StorefrontCatalogScalar,
    StorefrontPlanScalar
} from '~/resources/scalars/storefront-catalog-scalar'
import { isApp } from '~/composables/use-org'
import { computed } from 'vue'
import ContentReset from '~/components/ContentReset.vue'

const props = defineProps<{
    child:
        | StorefrontCalendarScalar
        | StorefrontPlanScalar
        | StorefrontCatalogScalar
}>()

const redpointApp = isApp()
const callToActionLanguage = computed(() => {
    if (props.child.__typename !== 'StorefrontPlan') {
        return 'Explore'
    }

    if (redpointApp.value) {
        return 'Join Now'
    } else {
        return props.child.planType === 'AGREEMENT'
            ? 'Fill Out Now'
            : props.child.planType === 'PROGRAM'
            ? 'Book Now'
            : 'Purchase Now'
    }
})
</script>
